import { render, staticRenderFns } from "./total-tvl.vue?vue&type=template&id=2eeead20&scoped=true&"
import script from "./total-tvl.vue?vue&type=script&lang=js&"
export * from "./total-tvl.vue?vue&type=script&lang=js&"
import style0 from "./total-tvl.vue?vue&type=style&index=0&id=2eeead20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeead20",
  null
  
)

export default component.exports